
import Main from '../views/main';
import BusinessmanList from '../views/businessmanManagement/businessmanList'
import BalanceList from '../views/businessmanManagement/balanceList'
import RechargeList from '../views/businessmanManagement/rechargeList'
const BusinessRouter = {

    path: '/Business',
    component: Main,
    title: '商人管理',
    icon: 'el-icon-s-custom',
    meta: { keepAlive: true },
    children: [
      {
        path: '/businessmanList',
        component:BusinessmanList,
        name: 'BusinessmanList',
        title: '商人列表',
        meta: { title: '商人列表' ,keepAlive:true}
      },
      {
        path: '/balanceList',
        component:BalanceList,
        name: 'BalanceList',
        title: '商人上分列表',
        meta: { title: '商人上分列表' ,keepAlive:true}
      },
      {
        path: '/rechargeList',
        component:RechargeList,
        name: 'RechargeList',
        title: '商人代充订单',
        meta: { title: '商人代充订单' ,keepAlive:true}
      }
    ]

}
export default BusinessRouter